import fly from '../fly'

export const getPageInfo = (param) =>{
  return fly.post("/operationlog/page",param)
}

